namespace GeniuzPOS.LogManage {
    export interface LogUserLockErrorPasswordForm {
        Username: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        UserErrorStampFg: Serenity.IntegerEditor;
    }

    export class LogUserLockErrorPasswordForm extends Serenity.PrefixedContext {
        static formKey = 'LogManage.LogUserLockErrorPassword';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LogUserLockErrorPasswordForm.init)  {
                LogUserLockErrorPasswordForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(LogUserLockErrorPasswordForm, [
                    'Username', w0,
                    'ShopId', w0,
                    'DisplayName', w0,
                    'Email', w0,
                    'UserErrorStampFg', w1
                ]);
            }
        }
    }
}
